module.exports = __webpack_public_path__ + "img/digitaleyes.5044516c.png";